import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AttendanceService } from '../../../../../services/attendance-service/attendance.service';
import { DatePipe } from '@angular/common';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrl: './employee-details.component.scss',
  providers: [DatePipe]
})
export class EmployeeDetailsComponent implements OnInit {
  constructor(private attendanceService: AttendanceService, private datePipe: DatePipe, private cd: ChangeDetectorRef) { }

  currentDate: any;
  currentMonth: any = [];
  userDetail: any = {};
  userAttendance: any = {};
  selectedDate: any;
  selectedMonth: any;
  selectedMonthText: any = '';
  selectedYear: any;
  attendanceDataFetch: any = [];
  numberOfDays: number = 0;

  page: any = 0;
  size: any = 6;

  // Your data
  totalPages: any;
  currentPage = 0;
  pageNumbers: number[] = [];

  fullMonthData: any[] = [];

  employeeId: any;

  ngOnInit(): void {
    this.currentMonth = [];
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0];

    const selectedDateObj = new Date;
    this.selectedMonth = selectedDateObj.getMonth() + 1;
    this.selectedYear = selectedDateObj.getFullYear();
    this.selectedMonthText = this.datePipe.transform(selectedDateObj, 'MMM')

    let currentMonth = this.getDaysInMonth(selectedDateObj.getFullYear(), selectedDateObj.getMonth());
    for (let i = 1; i <= currentMonth; i++) {
      this.currentMonth.push(i);
    }

    this.getSingleEmployee();
    this.getAttendanceDetail(this.selectedYear, this.selectedMonth, this.selectedMonthText)
  }

  generatePageNumbers() {
    this.pageNumbers = [];
    for (let i = 0; i < this.totalPages; i++) {
      this.pageNumbers.push(i); // Push page numbers into the array
    }
  }

  changePage(page: number) {
    if (page < 0 || page >= this.totalPages) {
      return;
    }
    this.currentPage = page;
    this.loadPageData(page);
  }

  loadPageData(page: number) {
    this.page = page;
    this.getAttendanceDetail(this.selectedYear, this.selectedMonth, this.selectedMonthText);
  }

  onDateChange(): void {
    this.currentMonth = [];
    if (this.selectedDate) {
      const selectedDateObj = new Date(this.selectedDate);
      this.selectedMonth = selectedDateObj.getMonth() + 1;
      this.selectedMonthText = this.datePipe.transform(this.selectedDate, 'MMM');
      this.selectedYear = selectedDateObj.getFullYear();
    }
    const date = new Date(this.selectedDate);
    let currentMonth = this.getDaysInMonth(date.getFullYear(), date.getMonth());
    for (let i = 1; i <= currentMonth; i++) {
      this.currentMonth.push(i);
    }
    this.getAttendanceDetail(this.selectedYear, this.selectedMonth, this.selectedMonthText);
    this.cd.detectChanges();
  }

  getDaysInMonth(year: number, month: number): number {
    const date = new Date(year, month + 1, 0);
    return date.getDate();
  }

  dateofMonth: any = [];
  getAttendanceDetail(selectedYear: any, selectedMonth: any, selectedMonthText: any) {
    this.selectedMonthText = selectedMonthText;
    this.attendanceService.getUserAttendance(selectedYear, selectedMonth, this.page, this.size, 5).subscribe({
      next: resp => {
        this.totalPages = resp.data.totalPages;
        this.attendanceDataFetch = resp.data.datas;
        this.fullMonthData = resp.data.fullMonthData;
        this.generatePageNumbers();
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getSingleEmployee() {
    let temp = localStorage.getItem('auth_user')
    let employee = temp ? JSON.parse(temp) : ""

    this.attendanceService.singleEmployee(Number(employee.userID)).subscribe({
      next: resp => {
        this.userDetail = resp.data;
        this.employeeId = resp.data.id;
        this.userAttendance = resp.attendanceData;
      },
      error: err => {
        console.log(err)
      }
    })
  }

  loadEmployeesLazy(event: TableLazyLoadEvent) {
    // Get the pagination and sorting parameters
    const page = (event.first ?? 0) / (event.rows ?? 10); // Default page size is 10
    const pageSize = event.rows ?? 10;
    const sortField = event.sortField;
    const sortOrder = event.sortOrder;

    const currentDate = new Date();
    const dubaiDate = new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'Asia/Dubai'
    }).format(currentDate);


    // this.currentdate = dubaiDate
    // // Make an API call with these parameters
    // this.attendanceService.getEmployees(this.currentdate, page, pageSize, sortField, sortOrder).subscribe({
    //     next: (data) => {
    //         this.attendanceData = data.data.datas;
    //         this.employees = this.attendanceData.map(item => {
    //             const { employee, ...attendanceData } = item;
    //             return { ...attendanceData, ...employee };
    //         });
    //         this.totalRecords = data.totalItems;
    //         this.loading = false;
    //     },
    //     error: (error) => {
    //         this.loading = false;
    //     },
    // });
  }


}
